<template>
  <div class="page-container">
    <Filter :params="params" @search="searchData">
      <template #handle>
        <el-form-item>
          <el-button type="primary" plain @click="exportData">{{$t('activity.packetjoin.export')}}</el-button>
        </el-form-item>
      </template>
    </Filter>
    <Table :tableData="tableDataList" :total="total" @update="updatePage">
      <el-table-column type="index" align="center" :label="$t('pages.indexNo')" width="60px" />
      <el-table-column prop="userName" :label="$t('activity.points.name')" />
      <el-table-column prop="createTime" :label="$t('activity.sale.regTime')" />
      <el-table-column prop="phoneNumber" :label="$t('activity.packetjoin.phone')">
        <template #default="{row}">
          {{ row.phoneNumber &&  (String(row.phoneNumber).slice(0,3)+'****'+String(row.phoneNumber).slice(7))}}
        </template>
      </el-table-column>
      <el-table-column prop="userEmail" :label="$t('activity.sale.email')" />
      <el-table-column prop="company" :label="$t('activity.sale.company')" />
      <el-table-column prop="type" :label="$t('activity.list.actType')" />
      <el-table-column prop="name" :label="$t('activity.list.actName')" />
      <el-table-column :label="$t('activity.sale.actTime')" >
        <template #default="{row}">{{ row.startDate }} - {{ row.endDate }}</template>
      </el-table-column>
      <el-table-column prop="saleName" :label="$t('activity.sale.salesperson')" />
    </Table>
  </div>
</template>

<script>
import { reactive, toRefs } from "@vue/reactivity";
// import { ElMessage } from "element-plus";

import Table from "@/components/table/index";
import Filter from "@/components/table/filter";
import useActivity from './useActivity';
import { useI18n } from 'vue-i18n'
import { request, downloadFile } from "@/utils/request";
import { common } from "@/common/mixin";

export default {
  components: {
    Table,
    Filter,
  },
  mixins: [common],
  setup() {
    const { t } = useI18n()
    const { activityTypeList } = useActivity()
    const state = reactive({
      query: {},
      page: 1,
      size: 10,
      total: 0,
      tableDataList: [],
      params: [
        {
          type: "Input",
          key: "name",
          value: "",
          label: t('activity.list.actName'),
        },
        {
          type: "Select",
          key: "type",
          value: "",
          label: t('activity.list.actType'),
          options: {
            data: activityTypeList,
            label: "translatedValue",
            value: "value"
          }
        },
        {
          type: "Input",
          key: "saleName",
          value: "",
          label: t('activity.sale.salesperson'),
        },
        {
          type: "Date",
          key: "dateRange",
          value: [],
          label: t('activity.list.date'),
          options: {
            "type": "daterange",
            "format": "YYYY-MM-DD",
            "value-format": "YYYY-MM-DD",
            "range-separator": t('activity.detail.to'),
            "start-placeholder": t('activity.list.startDate'),
            "end-placeholder": t('activity.list.endDate')
          }
        }, 
      ]
    })
    const getData = async () => {
      try {
        const res = await request("getSalePageList", {
          ...state.query,
          page: state.page,
          size: state.size,
        })
        state.tableDataList = res.records;
        state.total = res.total;
      } catch (error) {
        console.error(error);
      }
    };
    const searchData = async (data) => {
      state.query = data
      if (data.dateRange && data.dateRange.length>0) {
        state.query.startTime = data.dateRange[0]
        state.query.endTime = data.dateRange[1]
      } else {
        state.query.startTime = ''
        state.query.endTime = ''
      }
      getData()
    }
    const updatePage = (page, size) => {
      state.page = page || 1
      state.size = size || 10
      getData()
    }
    const exportData = async () => {
      try {
        const res = await downloadFile("exportSalePageList", {}, {
          method: 'GET',
          params: state.query
        });
        // let blob = new Blob([res],{type: "application/octet-stream"})
        let reader = new FileReader();
        reader.readAsDataURL(res);
        reader.onload = (e) => {
          const a = document.createElement('a')
          a.download = t('activity.sale.salesRecord')
          a.href = e.target.result
          a.click()
        }
      } catch (error) {
        console.error(error)
      }
    }
    getData();
    return {
      ...toRefs(state),
      getData,
      searchData,
      updatePage,
      exportData
    };
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
</style>
